import { render, staticRenderFns } from "./MerchantBusinessDetailsManagement.vue?vue&type=template&id=6f6dedcf&"
import script from "./MerchantBusinessDetailsManagement.vue?vue&type=script&lang=js&"
export * from "./MerchantBusinessDetailsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports